import { motion } from 'motion/react';
import ArrowUpIcon from './ArrowUpIcon';
import { PopWrapper } from './PopWrapper';

export let ScrollToTopButton = ({
  shouldShow,
  onScrollToTop,
  prefersLeftHandMode,
}: {
  shouldShow: boolean;
  onScrollToTop: () => void;
  prefersLeftHandMode?: boolean;
}) => {
  return (
    <motion.div
      className="absolute z-10 w-fit"
      style={{
        top: 60,
        ...(prefersLeftHandMode ? { left: 16 } : { right: 16 }),
      }}
      initial={{ opacity: 0, x: prefersLeftHandMode ? -80 : 80 }}
      animate={{
        opacity: shouldShow ? 1 : 0,
        x: shouldShow ? 0 : prefersLeftHandMode ? -80 : 80,
      }}
      transition={{ type: 'spring', stiffness: 340, damping: 32 }}
      onClick={onScrollToTop}
    >
      <PopWrapper>
        <div className="bg-neutral-0 flex items-center justify-center rounded-full border-4 border-neutral-100 p-1 shadow-md">
          <ArrowUpIcon className="size-5 text-rose-500" />
        </div>
      </PopWrapper>
    </motion.div>
  );
};
